import * as React from 'react';

import { NextPage } from 'next';
import { NextSeo, NextSeoProps } from 'next-seo';

import { paths } from '@paths';
import { generatePath } from '@utils/core';

import { PrismicPageQuery } from '@prismic/gqlTypes/prismicOperations';

import Page from './Page';

export interface ViewProps {
  params: { slug: string };
  page: PrismicPageQuery['page'] | null;
  seo: NextSeoProps | null;
}

const View: NextPage<ViewProps> = ({ page, seo, params: { slug } }) => {
  const breadcrumbs = [
    {
      link: '/',
      value: 'Home',
    },
    {
      link: generatePath(paths.page, { slug }),
      value: slug.replace(/-/g, ' '),
    },
  ];

  return (
    <>
      <NextSeo {...seo} />
      <Page content={page} breadcrumbs={breadcrumbs} />
    </>
  );
};

View.displayName = 'PrismicPageView';

export default View;
